// 初始化默认的回调对象，避免污染全局
const DEFAULT_FN = {}

function web_socket(url, token = null) {
    // 1. 配置参数
    this.url = url
    this.token = token
    this.reconcat_time = 1000 // 当前重连间隔
    this.timeout = 20000       // 心跳发送间隔 (20秒)
    this.pongTimeout = 5000    // 等待服务器响应超时时间 (5秒)

    // 2. 定时器句柄
    this.heartbeatTimer = null // 心跳触发定时器
    this.serverTimeoutTimer = null // 服务器响应超时定时器

    // 3. 状态与数据维护
    this.ws = null
    this.active = true         // 是否激活重连（主动close后为false）
    this.needInit = false      // 是否需要触发重连回调
    this.group = {}            // 订阅的分组信息
    this.fn = { ...DEFAULT_FN } // 消息回调函数集
    this.reloadFn = null       // 重连自定义执行函数
    this.messageQueue = []     // 离线消息队列

    // 4. 方法绑定
    this.init = init
    this.connect = connect
    this.startHeartbeat = startHeartbeat
    this.resetHeartbeat = resetHeartbeat
    this.send = send
    this.setToken = setToken
    this.addFn = addFn
    this.removeFn = removeFn
    this.joinGroup = joinGroup
    this.leaveGroup = leaveGroup
    this.close = close
    this.reloadData = reloadData

    // 【修复 ESLint】显式挂载私有断开处理函数，消除 no-unused-vars 报错
    this.onCloseHandler = onCloseHandler

    // 5. 执行初始化连接
    this.connect()
}

// 连接与事件监听
function connect() {
    this.active = true

    try {
        this.ws = new WebSocket(this.url)
    } catch (error) {
        // console.error("WebSocket 创建失败:", error)
        this.onCloseHandler()
        return
    }

    // 建立连接成功
    this.ws.onopen = () => {
        // console.log("WebSocket 连接成功")

        // 断网重连后的业务回调
        if (this.needInit && typeof this.fn['onreconcat'] === 'function') {
            this.fn['onreconcat']()
        }

        // 1. 发送鉴权 Token
        if (this.token) {
            this.ws.send(JSON.stringify({ type: "token", token: this.token }))
        }

        // 2. 重新订阅之前的分组
        for (let key in this.group) {
            this.ws.send(JSON.stringify({ type: "joinGroup", group: key }))
        }

        // 3. 执行重载业务数据方法
        if (this.reloadFn) this.reloadFn()

        // 4. 重置重连时间，并开启双向心跳检测
        this.reconcat_time = 1000
        this.startHeartbeat()

        // 5. 消费并补发因断线卡在队列中的离线消息
        while (this.messageQueue.length > 0) {
            const offlineData = this.messageQueue.shift()
            this.send(offlineData)
        }
    }

    // 收到消息
    this.ws.onmessage = e => {
        // 只要收到任何消息，都说明通道是健康的，重置心跳计时
        this.resetHeartbeat()

        try {
            const res = JSON.parse(e.data)

            // 心跳应答处理
            if (res.type === 'ping' || res.type === 'pong') {
                // 如果后端发的是 ping，前端回 pong（兼容部分旧后端设计）
                if (res.type === 'ping') {
                    this.ws.send(JSON.stringify({ type: "pong" }))
                }
                return
            }

            // 业务消息分发
            if (res.type === 'group') {
                if (typeof this.group[res.fn] === 'function') this.group[res.fn](res.data)
            } else if (res.type === 'fn') {
                if (typeof this.fn[res.fn] === 'function') this.fn[res.fn](res.data)
            }
        } catch (err) {
            console.error("WebSocket 消息解析失败:", err)
        }
    }

    // 连接断开
    this.ws.onclose = () => {
        this.onCloseHandler()
    }

    // 触发异常
    this.ws.onerror = (err) => {
        console.error("WebSocket 报错:", err)
        // onerror 之后一般会紧接着触发 onclose，此处不重复写重连逻辑
    }
}

// 统一的断开处理逻辑
function onCloseHandler() {
    // 清理所有心跳定时器，防止内存泄漏
    if (this.heartbeatTimer) clearTimeout(this.heartbeatTimer)
    if (this.serverTimeoutTimer) clearTimeout(this.serverTimeoutTimer)

    if (typeof this.fn['onclose'] === 'function') {
        this.needInit = true
        this.fn['onclose']()
    }

    // 如果是主动关闭的，则不进行自动重连
    if (!this.active) return

    // 渐进式指数退避重连延迟（1s -> 2s -> 3s -> 4s -> 5s）
    // console.warn(`WebSocket 已断开，将在 ${this.reconcat_time}ms 后尝试重连...`)
    setTimeout(() => {
        this.connect()
    }, this.reconcat_time)

    this.reconcat_time = Math.min(this.reconcat_time + 1000, 5000)
}

// 双向保活心跳控制
function startHeartbeat() {
    if (this.heartbeatTimer) clearTimeout(this.heartbeatTimer)
    if (this.serverTimeoutTimer) clearTimeout(this.serverTimeoutTimer)

    // 到了设定时间（20s），向后端发送心跳
    this.heartbeatTimer = setTimeout(() => {
        if (this.ws && this.ws.readyState === 1) {
            // console.log("WebSocket 发送心跳检测...")
            this.ws.send(JSON.stringify({ type: "ping" }))

            // 发送 ping 的同时，开启一个推迟 5 秒的“断线绝杀定时器”
            // 如果 5 秒内后端没回任何消息触发 resetHeartbeat() 来清除它，说明链路已死
            this.serverTimeoutTimer = setTimeout(() => {
                // console.error("心跳超时，服务器未应答，强制断开并触发重连")
                if (this.ws) this.ws.close() // 主动关闭以触发 onclose 重新连接
            }, this.pongTimeout)
        }
    }, this.timeout)
}

// 收到任何消息时，重置心跳
function resetHeartbeat() {
    if (this.heartbeatTimer) clearTimeout(this.heartbeatTimer)
    if (this.serverTimeoutTimer) clearTimeout(this.serverTimeoutTimer)
    this.startHeartbeat()
}

// 带离线队列的安全发送方法
function send(data) {
    if (this.ws && this.ws.readyState === 1) {
        this.ws.send(JSON.stringify(data))
    } else {
        if (!this.active) return
        // console.warn("WebSocket 尚未连接或已断开，消息已送入离线队列暂存:", data)
        // 将发不出去的消息暂存进数组，等连上后再补发，防止客服发送失败
        this.messageQueue.push(data)
    }
}

// 主动初始化（离开房间）
function init() {
    if (this.ws && this.ws.readyState === 1) {
        for (let key in this.group) {
            this.ws.send(JSON.stringify({ type: "leaveGroup", group: key }))
        }
    }
    this.group = {}
    this.fn = { ...DEFAULT_FN }
    this.reloadFn = null
    this.messageQueue = []
}

// 动态修改 Token
function setToken(token) {
    this.token = token
    if (this.ws && this.ws.readyState === 1) {
        this.ws.send(JSON.stringify({ type: "token", token: token }))
    }
}

function addFn(name, fn) { this.fn[name] = fn }
function removeFn(name) { delete this.fn[name] }

function joinGroup(group, fn) {
    this.group[group] = fn
    if (this.ws && this.ws.readyState === 1) {
        this.ws.send(JSON.stringify({ type: "joinGroup", group: group }))
    }
}

function leaveGroup(group) {
    delete this.group[group]
    if (this.ws && this.ws.readyState === 1) {
        this.ws.send(JSON.stringify({ type: "leaveGroup", group: group }))
    }
}

function reloadData(fn) { this.reloadFn = fn }

// 主动销毁退出
function close() {
    this.active = false
    this.messageQueue = []
    if (this.heartbeatTimer) clearTimeout(this.heartbeatTimer)
    if (this.serverTimeoutTimer) clearTimeout(this.serverTimeoutTimer)
    if (this.ws) {
        this.ws.close()
        this.ws = null
    }
}

export default web_socket